import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return [
      "columnMatching",
      "columnSelect",
      "headerRowCheckbox",
      "matchingNotOkHint",
      "newCustomAttributeModal",
      "submit",
      "newCustomAttributeButton",
      "newCustomAttributeInput",
    ]
  }

  static values = {
    campaignPresent: Boolean,
  }

  connect() {
    var _this = this

    this.selectOptionFromMatchedColumns()
    this.toggleSubmitButtonState()

    this.headerRowCheckboxTarget.addEventListener("change", function () {
      _this.toggleFirstLineDisplay()
    })

    this.columnSelectTargets.forEach(function (target) {
      target.addEventListener("change", function (e) {
        _this.handleSelectOptionChange(e.target)
      })
    })

    this.newCustomAttributeButtonTarget.addEventListener("click", function () {
      _this.createCustomAttribute()
    })
  }

  // Use the value from the hidden column matching input to set the right
  // select values.
  selectOptionFromMatchedColumns() {
    if (this.columnMatchingTarget.value === "{}") {
      return
    }

    $.each(JSON.parse(this.columnMatchingTarget.value), function (key, value) {
      if (document.getElementById(`column_${value}`) !== null) {
        document.getElementById(`column_${value}`).value = key
      }
    })

    this.disableMatchedColumns()
  }

  // When a value is selected in any of the selects, it must not be
  // selectable in another one
  disableMatchedColumns() {
    var matchedColumns = []

    this.columnSelectTargets.forEach(function (target) {
      matchedColumns.push(target.value)
    })

    $(this.columnSelectTargets)
      .children("option")
      .each(function () {
        // The option must be disabled if it's in the matched columns
        // and it's selected in another select
        if (
          this.value === "" ||
          this.value === $(this).parent("select").val() ||
          matchedColumns.includes(this.value) === false
        ) {
          this.removeAttribute("disabled")
        } else {
          this.setAttribute("disabled", true)
        }
      })
  }

  // Show or hide the first tr depending on if the checkbox is checked or not
  toggleFirstLineDisplay() {
    if (this.headerRowCheckboxTarget.checked) {
      $("tr[class='first']").fadeOut()
    } else {
      $("tr[class='first']").fadeIn()
    }
  }

  // When the value of a select changes, update the column matching or open the
  // modal to create a new custom attribute.
  handleSelectOptionChange(element) {
    if (element.value === "new_custom_attribute") {
      App.modal($(this.newCustomAttributeModalTarget), "show")
      return
    }

    this.updateColumnMatching()
  }

  // Store in an hidden field a hash of the matching, and handle the behaviour
  // of the form.
  updateColumnMatching() {
    var columnMatching = {}

    this.columnSelectTargets.forEach(function (target) {
      if (target.value !== "" && target.value !== "new_custom_attribute") {
        columnMatching[target.value] = target.id.replace("column_", "")
      }
    })

    this.columnMatchingTarget.value = JSON.stringify(columnMatching)

    this.disableMatchedColumns()
    this.toggleSubmitButtonState()
  }

  // Prevent the form to be submitted and show a hint if the email column
  // isn't matched.
  toggleSubmitButtonState() {
    const selectedValues = this.columnSelectTargets
      .map((target) => {
        return target.value
      })
      .filter((value) => {
        return value !== ""
      })

    let validColumnSelection
    if (this.campaignPresentValue) {
      validColumnSelection = selectedValues.includes("email")
    } else {
      validColumnSelection =
        selectedValues.includes("email") ||
        ((selectedValues.includes("full_name") ||
          (selectedValues.includes("first_name") && selectedValues.includes("last_name"))) &&
          (selectedValues.includes("website") || selectedValues.includes("company")))
    }

    if (validColumnSelection) {
      $(this.matchingNotOkHintTarget).hide()
      this.submitTarget.removeAttribute("disabled")
      return
    }

    $(this.matchingNotOkHintTarget).show()
    this.submitTarget.setAttribute("disabled", true)
  }

  // Create the new custom attribute on the server side.
  createCustomAttribute() {
    var _this = this

    this.newCustomAttributeButtonTarget.setAttribute("disabled", true)

    fetch("/leads/custom-attributes", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({
        lead_custom_attribute: {
          label: _this.newCustomAttributeInputTarget.value,
        },
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        _this.newCustomAttributeButtonTarget.removeAttribute("disabled")

        if (response.hasOwnProperty("errors")) {
          App.displayFlash(
            "danger",
            i18n.t("js.back.lead_import_configuration.failed_to_create_attribute", { error: response.errors }),
          )
          return
        }

        App.displayFlash(
          "success",
          i18n.t("js.back.lead_import_configuration.attribute_created", { label: response.label }),
        )

        App.modal($(_this.newCustomAttributeModalTarget), "hide")
        _this.newCustomAttributeInputTarget.value = ""
        _this.addCustomAttributeToSelects(response.label, response.slug)
        _this.resetSelectWithNewCustomAttribute(response.slug)
        _this.updateColumnMatching()
      })
  }

  addCustomAttributeToSelects(label, slug) {
    var value = `lead_custom_attribute_${slug}`

    this.columnSelectTargets.forEach(function (target) {
      var option = document.createElement("option")
      option.value = value
      option.innerHTML = label

      target.add(option)
    })

    this.resetSelectWithNewCustomAttribute(value)
  }

  // Reset the select with "New custom attribute" selected to its blank state.
  resetSelectWithNewCustomAttribute(value) {
    this.columnSelectTargets.forEach(function (target) {
      if (target.value === "new_custom_attribute") {
        target.value = value
      }
    })
  }
}
